import * as React from 'react';
import parseISO from 'date-fns/parseISO';

import * as A from 'fp-ts/Array';
import { Redirect } from 'react-router-dom';
import { FullMatchFragment } from '../../generated/graphql';
import { useTitle } from '../../useTitle';

import { MatchPendingText } from '../Match/MatchPendingText';

import { paths } from '../../paths';

import { VotingInProgress } from './VotingInProgress';

interface Props {
  match: FullMatchFragment;
}

export const Votes = ({ match }: Props) => {
  useTitle(`Match vs ${match.opponent}`);

  if (A.isEmpty(match.team.voteTypes)) {
    return <p>Voting is currently disabled</p>;
  }

  if (match.votingStatus === 'ACTIVE') {
    return <VotingInProgress match={match} />;
  }

  if (match.votingStatus === 'PENDING') {
    return <MatchPendingText playedAt={parseISO(match.playedAt)} />;
  }

  // voting has closed
  if (match.voteCount === 0) {
    return <p>There were no votes cast for this match 😕.</p>;
  }

  return <Redirect to={paths.match.home(match.id)} />;
};
